import { useDroppable } from '@dnd-kit/core';
import { Box } from '@mui/material';
import { buildSectionDroppableId } from '../utils/catalogDragAndDrop.utils';
import CatalogDropIndicator, {
  INDICATOR_THICKNESS,
} from './CatalogDropIndicator/CatalogDropIndicator';
import CatalogSectionEmptyPlaceholder from './CatalogSectionEmptyPlaceholder';

interface CatalogSectionEmptyDropZoneProps {
  sectionId: string;
  isDropTarget: boolean;
}

const CatalogSectionEmptyDropZone = ({
  sectionId,
  isDropTarget,
}: CatalogSectionEmptyDropZoneProps) => {
  const { setNodeRef } = useDroppable({ id: buildSectionDroppableId(sectionId) });

  return (
    <Box ref={setNodeRef} sx={{ position: 'relative' }}>
      {isDropTarget && (
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            height: INDICATOR_THICKNESS,
          }}
        >
          <CatalogDropIndicator orientation="horizontal" />
        </Box>
      )}

      <CatalogSectionEmptyPlaceholder />
    </Box>
  );
};

export default CatalogSectionEmptyDropZone;
